export default __webpack_public_path__ + "static/media/bibliotecaNormas_renewed.dcb9be4e.png";